import { App, Button, Card, Col, Flex, Form, Input, Modal, Row, Space } from "antd";
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";

export function ProfileEdit(){
    const [form] = Form.useForm();
    const [showSubmit,setShowSubmit] = useState(false);
    const navigate = useNavigate();

    const { message, notification } = App.useApp();

    useEffect(()=>{
        if(sessionStorage.getItem('status')=='Outsider')
            { 
                axios.get(`${process.env.REACT_APP_BASE}/getOutsiderdata/${sessionStorage.getItem('user')}`).then(response=>{
                if(response.status==200){
                    form.setFieldsValue(response.data[0])
                }
            })}
    },[])

    function saveEdit(){
        const FormData = form.getFieldsValue()
        const Data = {
            THfullname:FormData.THfullname||'',
            ENfullname:FormData.ENfullname||'',
            position:FormData.position||'',
            facility:FormData.facility||'',
            wp_address:FormData.wp_address||'',
            home_address:FormData.home_address||'',
            home_tel:FormData.home_tel||'',
            wp_tel:FormData.wp_tel||'',
            researcher_phone:FormData.researcher_phone||'',
            user_email:FormData.user_email||'',
        }
        axios.post(`${process.env.REACT_APP_BASE}/UpdateOutsiderProfile/${sessionStorage.getItem('user')}`,Data).then(response=>{
            if(response.status==200){
                navigate('/VU_HREC')
            }else{
                setShowSubmit(false)
                notification.error({
                    message: "เข้าสู่ระบบไม่สำเร็จ",
                });
            }
        })
    console.log(Data)
    }

    if(sessionStorage.getItem('status')=='Outsider')
    {return(
        <>
            <h1>แก้ไขข้อมูลส่วนตัว</h1>
            <hr/>
            <br/>
            <Form wrapperCol={{ span: 50 }}
                form={form}
                layout="vertical">
            <Card>
                <Row>
                    <Col span={10} >
                        <Form.Item name='THfullname' label='ชื่อ-นามสกุล (ภาษาไทย) : '>
                            <Input style={{marginLeft:20}}/>
                        </Form.Item>
                        <Form.Item name='position' label='ตำแหน่งงาน : '>
                            <Input style={{marginLeft:20}}/>
                        </Form.Item>
                    </Col>
                    <Col span={3}>
                    </Col>
                    <Col style={{marginLeft:20,marginRight:2}} span={10}>
                        <Form.Item name='ENfullname' label='ชื่อ-นามสกุล (ภาษาอังกฤษ) : '>
                            <Input style={{marginLeft:20}}/>
                        </Form.Item>
                        <Form.Item name='facility' label='สังกัด : '>
                            <Input style={{marginLeft:20}}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item style={{marginRight:20}} name='wp_address' label='ที่อยู่ที่ทำงาน : '>
                    <TextArea style={{marginLeft:20,marginRight:2}}/>
                </Form.Item>
                <Form.Item style={{marginRight:20}} name='home_address' label='ที่อยู่บ้าน : '>
                    <TextArea style={{marginLeft:20,marginRight:20}}/>
                </Form.Item>
                <Row>
                    <Col span={10} >
                        <Form.Item name='home_tel' label='โทรศัพท์(บ้าน) : '>
                            <Input style={{marginLeft:20}}/>
                        </Form.Item>
                        <Form.Item name='wp_tel' label='โทรศัพท์(ที่ทำงาน) : '>
                            <Input style={{marginLeft:20}}/>
                        </Form.Item>
                    </Col>
                    <Col span={3}>
                    </Col>
                    <Col style={{marginLeft:20,marginRight:2}} span={10}>
                        <Form.Item name='researcher_phone' label='เบอร์มือถือ : '>
                            <Input style={{marginLeft:20}}/>
                        </Form.Item>
                        <Form.Item name='user_email' label='e-mail : '>
                            <Input style={{marginLeft:20}}/>
                        </Form.Item>
                    </Col>
                </Row>
                <br/>
                <Flex justify='center'>
                    <Button onClick={()=>setShowSubmit(true)}>บันทึกข้อมูล</Button></Flex>
                <Modal
                    open={showSubmit}
                    onCancel={()=>setShowSubmit(false)}
                    footer={<></>}>
                        <h3>ยืนยันการแก้ไขข้อมูล</h3>
                        <hr/>
                        <p>ท่านยืนยันที่จะแก้ไขข้อมูลตามนี้หรือไม่</p>
                        <br/>
                        <p><span style={{fontWeight:'bold'}}>หมายเหตุ</span> การเปลี่ยนแปลง Email จะเปลี่ยน Email ที่ท่านใช้เข้าสู่ระบบ เปลี่ยนรหัสผ่าน และรับการแจ้งเตือน </p>
                        <p>กรุณาตรวจสอบให้ดีก่อนกดบันทึก</p>

                        <Form.Item label='กรุณากรอกรหัสผ่าน'>

                        </Form.Item>
                        <Flex justify='flex-end'>
                            <Button type='primary' onClick={()=>setShowSubmit(false)} danger>ยกเลิก</Button>&nbsp;
                            <Button type='primary' onClick={()=>saveEdit()}>ยืนยัน</Button>
                        </Flex>
                </Modal>
            </Card>
            </Form>
        </>
    )}else{
        return(<p>access denied</p>)
    }
}